import { fontSize } from 'config/constants';
import styled from 'styled-components';

export const Container = styled.div`
    text-align: center;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.colors.secondary.w000};
    font-size: ${fontSize.lg};
    font-weight: bold;
`;

export const Text = styled.p`
    color: ${({ theme }) => theme.colors.secondary.w000};
    margin-top: 10px;
    max-width: 250px;
    text-align: center;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;
    justify-content: center;

    @media (min-width: 600px) {
        flex-direction: row;
    }
`;

export const List = styled.ul`
    margin-top: 15px;
    color: #fff;
    max-height: 120px;
    overflow-y: auto;
    overflow-x: visible;
    &::-webkit-scrollbar {
        padding: 4px;
        width: 5px;
    }
    
    &::-webkit-scrollbar-track-piece {
    background: ${({ theme }) => theme.colors.secondary.w500};
    }

    &::-webkit-scrollbar-button {
    display: none;
    }

    &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary.w100};
    }
`;

export const ListItem = styled.li`
    text-align: left;
    margin-bottom: 4px;
`;
